// hooks/useDesktop.js
import { useState, useEffect } from 'react';

export const useDesktop = (breakpoint = 1024) => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkDesktop = () => {
      setIsDesktop(window.innerWidth >= breakpoint);
    };

    // Check on mount
    checkDesktop();

    // Add event listener
    window.addEventListener('resize', checkDesktop);

    // Cleanup
    return () => window.removeEventListener('resize', checkDesktop);
  }, [breakpoint]);

  return isDesktop;
};